import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import withApp from '@brainstud/react-tbl/core/provider/withApp'
// TODO move ui
// import { Page, Layout, LayoutContent } from '@brainstud/schiphol-vtc-ui'
// TODO get appRoutes from provider
import { appRoutes } from '@brainstud/react-tbl/features'
import { withModal } from '@brainstud/react-tbl/features/modals'
import { routePath, routeTo, getBySlug, getNextItem, getPrevItem, nextNavTo } from '@brainstud/react-helpers'
import { NavigationFooter, NavigationView } from '@brainstud/react-tbl/features/navigation'
import { setProgress } from '../store'
import { Views } from './'

class ChapterView extends React.Component {
  handleComplete = e => {
    if(this.props.nextTo) return

    // if(this.props.progress.remainingToSubmit > 0) {
    //   this.props.modal.open('quiz-incomplete', {
    //     current: this.props.progress.totalQuestions - this.props.progress.remainingToSubmit,
    //     total: this.props.progress.totalQuestions
    //   })
    // }

    // if(this.props.progress.remainingToSubmit <= 0) {
      this.props.setProgress(this.props.quiz.id, {
        completed: true,
      })

      this.props.modal.open('quiz-results', {
        nextTo: this.props.nextChapterTo,
        chapter: this.props.chapter.prefix,
        score: this.props.progress.currentScore,
        total: this.props.progress.totalPoints,
      })
    // }
  }

  render() {
    if(!this.props.quiz)
      return <Redirect to={routeTo(appRoutes, 'chapter', { chapter: this.props.chapter.slug })} />

    return (
      <NavigationView type="chapter" id={this.props.chapter.id}>
        <Page>
          <Layout toggleSidebar={this.props.app.toggleSidebar}>
            <LayoutContent main={
              <Switch>
                <Route path={routePath(appRoutes, 'quiz')} exact     component={Views.Intro} />
                <Route path={routePath(appRoutes, 'quiz-summary')}   component={Views.Summary} />
                <Route path={routePath(appRoutes, 'quiz-question')}  component={Views.Question} />
              </Switch>
            } />

            <NavigationFooter
              title="Oefentoets"
              homeButton
              prevButton
              prevLabel={this.props.prevLabel}
              prevTo={this.props.prevTo}
              nextButton
              nextLabel={this.props.nextLabel}
              nextTo={this.props.nextTo}
              nextClick={this.handleComplete} />
          </Layout>
        </Page>
      </NavigationView>
    )
  }
}

export default withApp(withModal(connect(
  (state, props) => {
    const navigation = state.navigation.list.byId
    const lessons = state.chapters.lessons.byId
    const chapters = state.chapters.chapters.byId
    const quizes = state.quizes.quizes.byId
    const questions = state.quizes.questions.byId
    const progressAll = state.quizes.progress

    const chapter = getBySlug(chapters, props.match.params.chapter)
    if(!chapter) return { chapter: false }

    const quiz = quizes[chapter.quizId]
    if(!quiz) return { chapter, quiz: false }

    const progress = progressAll[quiz.id]

    /* ----------------------- */

    const prevLesson = lessons[chapter.lessons[chapter.lessons.length-1]]
    const prevLessonTo = prevLesson
      ? routeTo(appRoutes, 'lesson', { chapter: chapter.slug, lesson: prevLesson.slug })
      : routeTo(appRoutes, 'chapter', { chapter: chapter.slug })

    const navItem = Object.values(navigation).find(item => item.chapterId === chapter.id)
    const nextChapterTo = nextNavTo(state, navItem, appRoutes)

    /* ----------------------- */

    const prevQuestion = getPrevItem(quiz.questions, questions, progress.question)
    const nextQuestion = getNextItem(quiz.questions, questions, progress.question)
    const firstQuestion = questions[quiz.questions[0]]

    const prevQuestionTo = prevQuestion
      ? routeTo(appRoutes, 'quiz-question', { chapter: chapter.slug, question: prevQuestion.prefix })
      : routeTo(appRoutes, 'quiz', { chapter: chapter.slug })

    const nextQuestionTo = nextQuestion
      ? routeTo(appRoutes, 'quiz-question', { chapter: chapter.slug, question: nextQuestion.prefix })
      : quiz.summary
        ? routeTo(appRoutes, 'quiz-summary', { chapter: chapter.slug })
        : false

    const startQuizTo = routeTo(appRoutes, 'quiz-question', { chapter: chapter.slug, question: firstQuestion.prefix })

    /* ----------------------- */

    const routes = {
      intro:    { prev: prevLessonTo, next: startQuizTo },
      question: { prev: prevQuestionTo, next: nextQuestionTo },
      summary:  { prev: prevQuestionTo, next: nextChapterTo },
    }

    const prevTo = routes[progress.location].prev
    const nextTo = routes[progress.location].next

    /* ----------------------- */

    const labels = {
      intro:    { prev: 'Vorige',       next: 'Start toets' },
      question: { prev: prevQuestion ? 'Vorige vraag' : 'Vorige', next: nextQuestion ? 'Volgende vraag' : 'Bekijk resultaat' },
      summary:  { prev: 'Vorige',       next: 'Volgend hoofdstuk' },
    }

    const prevLabel = labels[progress.location].prev
    const nextLabel = labels[progress.location].next

    /* ----------------------- */

    return { chapter, quiz, progress, questions, prevTo, prevLabel, nextTo, nextLabel, nextChapterTo }
  },
  (dispatch) => ({
    setProgress: (anyId, progress) => dispatch(setProgress(anyId, progress)),
  }),
)(ChapterView)))
